import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export function authInterceptor(
  httpRequest: HttpRequest<unknown>,
  httpHandler: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  return httpHandler(httpRequest.clone({ withCredentials: true }));
}
